import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#751230",
                secondary: "#d76c06",
                accent: "#000000",
                error: "#ed1d25",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#d76c06",
            },
            dark: {
                primary: "#751230",
                secondary: "#d76c06",
                accent: "#000000",
                error: "#ed1d25",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#d76c06",
            },
        },
    },
    icons: {
        iconfont: "md",
    },
});
